
export const widgetThemes = [
    {
        id: 'blue',
        name: 'Blue',
        mode: 'light',
        colors: {
            primary: '#4174F8',
            primaryHover: '#d9e3fe',
            secondary: '#9258FF',
            secondaryHover: '#e9deff',
            text: '#07294C',
            error: '#EE6A5F',
            success: '#0B9E2E',
            accent: '#7ED8CD',
        },
    },
    {
        id: 'darkEssenza',
        name: 'Dark Essenza',
        mode: 'dark',
        colors: {
            primary: '#B19664',
            primaryHover: '#090d1a',
            secondary: '#d0bd7e',
            secondaryHover: '#cecece',
            text: '#d3d3d3',
            error: '#cb0c1c',
            success: '#0B9E2E',
            accent: '#E8A85C',
        },
    },
    {
        id: 'essenza',
        name: 'Essenza',
        mode: 'light',
        colors: {
            primary: '#D0BD7E',
            primaryHover: '#f6f2e5',
            secondary: '#9E693D',
            secondaryHover: '#f6f2e5',
            text: '#0A0909',
            error: '#A80C19',
            success: '#0B9E2E',
            accent: '#D4944A',
        },
    },
    {
        id: 'riverSide',
        name: 'River Side',
        mode: 'light',
        colors: {
            primary: '#25A18E',
            primaryHover: '#d3ece8',
            secondary: '#63D5D0',
            secondaryHover: '#e0f7f6',
            text: '#222B29',
            error: '#F46262',
            success: '#0B9E2E',
            accent: '#E87040',
        },
    },
    {
        id: 'sienna',
        name: 'Sienna',
        mode: 'light',
        colors: {
            primary: '#495057',
            primaryHover: '#F8F9FA',
            secondary: '#6C757D',
            secondaryHover: '#dbdcdd',
            text: '#222B29',
            error: '#F46262',
            success: '#0B9E2E',
            accent: '#C4623A',
        },
    },
    {
        id: 'summer',
        name: 'Summer',
        mode: 'light',
        colors: {
            primary: '#3AC0FC',
            primaryHover: '#BAF0FC',
            secondary: '#FFBE7E',
            secondaryHover: '#fff2e5',
            text: '#424C50',
            error: '#FF8686',
            success: '#0B9E2E',
            accent: '#FF6B6B',
        },
    },
    {
        id: 'umbral',
        name: 'Umbral',
        mode: 'light',
        colors: {
            primary: '#2A3175',
            primaryHover: '#E6E7E8',
            secondary: '#00ADB6',
            secondaryHover: '#92D5E0',
            text: '#404041',
            error: '#EA525C',
            success: '#0B9E2E',
            accent: '#F7B731',
        },
    },
];

export const COLOR_FIELDS = [
    { key: 'primary',        labelKey: 'WidgetConfig.Primary',        icon: 'fa-solid fa-circle' },
    { key: 'primaryHover',   labelKey: 'WidgetConfig.PrimaryHover',   icon: 'fa-solid fa-circle-dot' },
    { key: 'secondary',      labelKey: 'WidgetConfig.Secondary',      icon: 'fa-solid fa-circle' },
    { key: 'secondaryHover', labelKey: 'WidgetConfig.SecondaryHover', icon: 'fa-solid fa-circle-dot' },
    { key: 'text',           labelKey: 'WidgetConfig.Text',           icon: 'fa-solid fa-font' },
    { key: 'error',          labelKey: 'WidgetConfig.Error',          icon: 'fa-solid fa-triangle-exclamation' },
    { key: 'success',        labelKey: 'WidgetConfig.Success',        icon: 'fa-solid fa-circle-check' },
    { key: 'accent',         labelKey: 'WidgetConfig.Accent',         icon: 'fa-solid fa-star' },
];